<template>
    <div>
        <el-input readonly
                  v-model="showName"
                  :size="size"
                  :placeholder="placeholder">
            <el-button @click="openSelect" slot="append">{{buttonText}}</el-button>
        </el-input>
        <Modal
                v-model="showSupplier"
                :title="modalTitle"
                :width="width">
            <RadioGroup v-model="selectSupplier" style="width: 100%">
                <Input v-model="query.name" style="width: 200px" clearable placeholder="请输入个体户名称"></Input>
                <Button type="primary" @click="searchSupplier" style="margin-left: 10px">查询</Button>
                <el-table
                        v-if="tableData!=null&&tableData.length>0"
                        :data="tableData"
                        size="mini"
                        border
                        stripe
                        @row-click="rowClick"
                        :header-row-style="()=>{return 'color: #5c6b77'}"
                        :header-cell-style="()=>{return 'background: #f8f8f9;line-height:35px'}"
                        style="width: 100%;margin-top: 10px">
                    <el-table-column prop="name"
                                     align="center"
                                     width="60"
                                     :show-overflow-tooltip="true"
                                     label="选择">
                        <template slot-scope="scope">
                            <Radio :label="scope.row.id">
                                <span></span>
                            </Radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     align="center"
                                     :show-overflow-tooltip="true"
                                     label="个体户名称">
                      <template slot-scope="scope">
                        <span v-if="scope.row.name">{{scope.row.name.indexOf("建企云")!=-1?(scope.row.name.substring(scope.row.name.indexOf("建企云")+3,scope.row.name.length)).replace("（个体工商户）",""):scope.row.name.replace("（个体工商户）","")}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="phone"
                                     align="center"
                                     :show-overflow-tooltip="true"
                                     label="电话">
                    </el-table-column>
                    <el-table-column prop="taxpayerNumber"
                                     align="center"
                                     :show-overflow-tooltip="true"
                                     label="统一社会信用代码">
                    </el-table-column>

                </el-table>
                <avue-empty v-else style="margin-top: 10px"></avue-empty>
            </RadioGroup>

            <div slot="footer">
                <Row>
                    <Col span="18">
                        <div style="display: flex;justify-content: flex-start;">
                            <Page v-if="count>0" style="margin-bottom: 10px" transfer @on-change="pageChange"
                                  :page-size="10"
                                  @on-page-size-change="sizeChange"
                                  :current="query.current"
                                  prev-text="上一页"
                                  next-text="下一页" :total="count" show-elevator show-total show-sizer/>
                        </div>
                    </Col>
                    <Col span="6">
                        <Button @click="okClear">清空</Button>
                        <Button type="primary" @click="okSelect">选择</Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    </div>
</template>

<script>
    import appUtils from '@/utils/appUtils';
    import {pageSupplier,getSupplier,} from '@/api/economy/supplier'

    export default {
        name: 'select-supplier',
        props: {
            //值
            value: {},
            //显示姓名
            name: {},
            //展位信息
            placeholder: {
                default: '请选择'
            },
            //弹出层标题
            modalTitle: {
                default: '选择个体户'
            },
            //弹出层宽度
            width: {
                default: '900'
            },
            //表单尺寸
            size: {
                default: 'small'
            },
            //按钮文字
            buttonText: {
                default: '选择'
            },
            supplierName:{
                type:String
            }
        },
        data() {
            return {
                //是否显示个体户选择弹窗
                showSupplier: false,
                //列表数据
                tableData: []
                //数据总行数
                , count: 0
                // 个体户查询条件
                , query: {
                    size: 10,
                    current: 1
                },
                //显示姓名
                showName: null,
                //已选择个体户
                selectSupplier: null
            }
        },
        watch: {
            name() {
                this.showName = this.name
            },
            value() {
                // if (this.value == null) {
                //     this.showName = null
                // } else {
                //     if (this.name == null) {
                //         this.getSupplier()
                //     }
                // }
            },
            supplierName(){
                this.showName = this.supplierName
            }
        },
        computed: {},
        methods: {
            /**
             * 根据ID获取个体户
             */
            getSupplier() {
                if (this.tableData==[] || this.tableData.length == 0){
                    getSupplier(this.value).then(res => {
                        if (res.state && res.data != null) {
                            this.showName = res.data.name
                        }
                    })
                } else{
                    let filter = this.tableData.filter(item=> item.id == this.value);
                    console.log(filter,'filter')

                }

            },
            /**
             * 获取数据
             */
            getData() {
                this.selectSupplier = null
                let loading = appUtils.showLoading()
                pageSupplier(this.query).then(res => {
                    appUtils.hideLoading(loading)
                    if (res.state) {
                        this.tableData = res.data.records
                        this.count = res.data.total
                    } else {
                        appUtils.showError(res.msg)
                    }
                }).catch(err => {
                    appUtils.hideLoading(loading)
                })
            },
            /**
             * 页数发生改变
             */
            pageChange(val) {
                this.query.current = val
                this.getData()
            },
            /**
             * 每页显示条数发生改变
             */
            sizeChange(val) {
                this.query.size = val
                this.query.current = 1
                this.getData()
            },
            /**
             * 打开选择个体户
             */
            openSelect() {
                this.showSupplier = true
                this.getData()
            },
            /**
             * 确认选择个体户
             */
            okSelect() {
                console.log(this.showName,'1111')
                this.$emit('input', this.selectSupplier)
                if (this.selectSupplier != null) {
                    let staff = this.tableData.filter(item => item.id == this.selectSupplier)
                    this.showName = staff[0].name
                } else {
                    this.showName = null
                }
                console.log(this.showName,'22222')
                this.showSupplier = false
            },
            /**
             * 清空选择个体户
             */
            okClear() {
                this.selectSupplier = null
                this.$emit('input', this.selectSupplier)
                this.showName = null
                this.showSupplier = false
            },
            searchSupplier() {
                this.query.current = 1
                this.getData()
            },
            /**
             * 单元格点击事件
             * @param row
             * @param column
             * @param event
             */
            rowClick(row, column, event) {
                this.selectSupplier = row.id
            }
        },
        mounted() {

        },
    }
</script>
